import type { IconNames } from '@common';
import type { CSSProperties, ReactElement } from 'react';

export enum WidgetType {
  SHOTEYES_STAR = 'ShotEyesStar',
  SHOTEYES_GRID = 'ShotEyesGrid',
  PLACEHOLDER = 'Placeholder',
  BLOCK = 'Block',
  SHOTEYES_IMAGE = 'ShotEyesImage',
  SHOTEYES_SIGNATURE = 'ShotEyesSignature',
  CALENDER = 'Calendar',
  NUMBER = 'Number',
  CHECKBOX = 'CheckBox',
  RADIOBOX = 'RadioBox',
  INPUT = 'Input',
  TEXTAREA = 'TextArea',
  RICHTEXT = 'RichText',
  SHOTEYES_BLANK_INPUT = 'ShotEyesBlankInput',
  SHOTEYES_SHORT_ANSWER = 'ShotEyesShortAnswer',
  SHOTEYES_USER = 'ShotEyesUser',
  SHOTEYES_AMOUNT = 'ShotEyesAmount',
}

export interface HighlighterProps {
  title: string;
  keyword?: string;
  className?: string | undefined;
  style?: CSSProperties;
  require?: boolean;
}
export interface DragItemProps {
  title: string;
  className?: string | undefined;
  style?: CSSProperties;
}

export interface IconProps {
  action: 'pass' | 'unpass' | 'na' | 'more' | 'input' | 'select' | 'empty' | 'pass-on';
  className?: string | undefined;
}

export interface ThumbnailProps {
  title: string;
  icon: IconNames;
  className?: string | undefined;
  toolTipContent?: ReactElement | string;
}

export enum SelectStyleEnum {
  LINE = 'Line',
  LIST = 'List',
  GRID = 'Grid',
  STAR = 'star',
  NUMBER_CIRCLE = 'numberCircle',
  HEART = 'heart',
  NUMBER_SQUARE = 'numberSquare',
}

export enum DirectionEnum {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}


export enum WidgetKind {
  WIDGET = 'widget'
}

export enum WidgetGroup {
  BLOCK = 'Block',
  SUBBLOCK = 'SubBlock',
  PLACEHOLDER = 'Placeholder',
}
